import r from "../oauth2-client/index.js";
class a {
  /**
   * Gets the current user's profile.
   */
  static getCurrentUser(e) {
    return r.getUserInfo(e);
  }
}
export {
  a as default
};
